module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Top traders from Futures market"},"es":{"title":"Mejores traders del mercado de  Futuros"}}')
  delete Component.options._Ctor
}
